module.exports = __webpack_public_path__ + "img/imgZXGH(9).6c965a27.png";